import React, { useState, useEffect, useRef, useContext } from 'react';
import Box from '@material-ui/core/Box';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import BasicConfig from './BasicConfig';
import InitialData from './InitialData';
import { Toast } from 'primereact/toast';
import { Link, useNavigate } from 'react-router-dom';
import NLU from './NLU';

import TemplateIntegration from '../../integrations/TemplateIntegration';
import { EnvContext } from '../Context/EnvProvider';
import { useAuthToken } from '../../hooks/useAuthToken';
import useQuery from '../../hooks/useQuery';

const templateIntegration = new TemplateIntegration();

const steps = ['Configurações básicas', 'NLU', 'Dados Iniciais'];


const handleSteps = (activeStep, props) => {
    switch (activeStep) {
        case 0:
            return <BasicConfig {...props} />
        case 1:
            return <NLU {...props} />
        case 2:
            return <InitialData {...props} />
        default:
            throw new Error('Unknown step')
    }
}

export default function BotTemplateForm() {
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setForm] = useState([]);
    const query = useQuery();
    const toast = useRef(null);
    const navigate = useNavigate();
    const { getAccessToken } = useAuthToken();

    const { environment } = useContext(EnvContext);

    useEffect(() => {
        let templateId = query.get("templateId");
        if (templateId) {
            const loadTemplate = async () => {
                try {
                    const authToken = await getAccessToken();
                    const data = await templateIntegration.getTemplate(environment.botApi, templateId, authToken);
                    setForm(data);
                } catch (error) {
                    console.error(error);
                    toast.current?.show({
                        severity: 'error',
                        summary: 'Erro!',
                        detail: 'Erro ao carregar o template.',
                        life: 5000,
                    });
                }
            };
            
            loadTemplate();
        }
        else {
            templateIntegration.createNewTemplate().then(data => {
                setForm(data);
            })
        }
    }, [environment.botApi, getAccessToken, query])



    const props = { formData, setForm };

    const totalSteps = () => {
        return steps.length;
    };

    const handleNext = () => {
        const newActiveStep = activeStep + 1;
        setActiveStep(newActiveStep);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = (step) => () => {
        setActiveStep(step);
    };
    const showResponseMessage = (json) => {
        if (json.status !== 400) {
            toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: "Template Salvo com Sucesso", life: 5000 });
            setTimeout(() => { navigate('/ListBotTemplates'); }, 5000);
        }
        else {
            toast.current.show({ severity: 'error', summary: 'Erro!', detail: json.error, life: 5000 });
        }

    }

    const handleSubmit = async () => {
        try {
            const authToken = await getAccessToken();
            const json = await templateIntegration.saveTemplate(environment.botApi, formData, authToken);
            showResponseMessage(json);
        } catch (error) {
            console.error(error);
            toast.current.show({ severity: 'error', summary: 'Erro!', detail: 'Erro ao salvar o template.', life: 5000 });
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Toast ref={toast} />
            <div className="card">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link to="/ListBotTemplates">Lista de Templates</Link>
                        </li>
                        <li className="breadcrumb-item active">
                            <span>Bot Template</span>
                        </li>
                    </ol>
                </nav>
            </div>
            <Stepper nonLinear activeStep={activeStep}>
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepButton color="inherit" onClick={handleStep(index)}>
                            {label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
            <div>
                {handleSteps(activeStep, props)}
                {activeStep === totalSteps() - 1 ? (
                    <React.Fragment>
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                            <Button
                                variant="contained"
                                sx={{ mt: 3, ml: 1 }}
                                color="primary"
                                disabled={activeStep === 0}
                                onClick={handleBack}

                            >
                                Voltar
                            </Button>
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button
                                variant="contained"
                                sx={{ mt: 3, ml: 1 }}
                                color="primary"
                                onClick={handleSubmit}
                            >
                                Salvar
                            </Button>
                        </Box>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                            <Button
                                variant="contained"
                                sx={{ mt: 3, ml: 1 }}
                                color="primary"
                                disabled={activeStep === 0}
                                onClick={handleBack}

                            >
                                Voltar
                            </Button>
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button
                                variant="contained"
                                sx={{ mt: 3, ml: 1 }}
                                color="primary"
                                onClick={handleNext}
                                disabled={activeStep === totalSteps() - 1}
                            >
                                Proximo
                            </Button>
                        </Box>
                    </React.Fragment>
                )}
            </div>
        </Box>
    );
}
